import {Avatar} from 'platform/components';
import {Box, HStack, Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useGetUserAvatarUrlQuery} from '@dms/api/customer';

import {suffixTestId, TestIdProps} from 'shared/web';

import {getUserName} from '../../../utils/getUserName';
import {OverviewRowButton} from './OverviewRowButton';

interface PersonnelOverviewListItemProps extends TestIdProps {
  userId: string;
  firstName: string;
  lastName: string;
  activeCount: number;
  isSelected: boolean;
  onClick: (userId: string) => void;
}

export function PersonnelOverviewListItem(props: PersonnelOverviewListItemProps) {
  const fullName =
    getUserName({firstName: props.firstName, lastName: props.lastName}, {reverse: true}) ?? '';
  const isDisabled = props.activeCount === 0 && !props.isSelected;

  const {data: avatarUrl} = useGetUserAvatarUrlQuery({userId: props.userId, height: 40, width: 40});

  const textColor = match({isSelected: props.isSelected, isDisabled})
    .with({isSelected: true}, () => 'link' as const)
    .with({isDisabled: true}, () => 'tertiary' as const)
    .otherwise(() => 'primary' as const);

  return (
    <OverviewRowButton
      type="button"
      disabled={isDisabled}
      onClick={() => props.onClick(props.userId)}
      aria-pressed={props.isSelected}
      data-testid={suffixTestId('personnelOverviewListItem', props)}
    >
      <HStack spacing={2} align="center">
        <Avatar
          size="xSmall"
          name={fullName}
          imageUrl={avatarUrl}
          color={props.isSelected ? 'palettes.blue.30.100' : undefined}
          textColor={props.isSelected ? 'link' : undefined}
        />
        <Box minWidth={0}>
          <Text size="small" color={textColor} noWrap>
            {fullName}
          </Text>
        </Box>
        <Box flexShrink={0}>
          <Text size="small" color={textColor} noWrap>{`· ${props.activeCount}`}</Text>
        </Box>
      </HStack>
    </OverviewRowButton>
  );
}
